import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ButtonModule } from "../button/index";
import { GenericModule } from "../generic/index";
import { IconModule } from "../icon/index";
import { MediaModule } from "../media/index";

import { DialogBaseService } from "./dialog.base.service";

import { DialogWrapperComponent } from "./components/wrapper/wrapper.component";
import { DialogComponent } from "./components/dialog/dialog.component";

import { DialogHeaderComponent } from "./components/partials/header/header.component";
import {
  DialogTitleComponent,
  DialogHeadingTitleComponent
} from "./components/partials/title/title.component";
import {
  DialogSubtitleComponent,
  DialogHeadingSubtitleComponent
} from "./components/partials/subtitle/subtitle.component";
import {
  DialogCloseComponent,
  DialogCloseDirective
} from "./components/partials/close/close.component";
import {
  DialogDismissComponent,
  DialogDismissDirective
} from "./components/partials/dismiss/dismiss.component";
import { DialogContentComponent } from "./components/partials/content/content.component";
import { DialogBodyComponent } from "./components/partials/body/body.component";
import { DialogFooterComponent } from "./components/partials/footer/footer.component";

export { DialogRef, DialogParams } from "./dialog.base";
export { DialogBaseService } from "./dialog.base.service";

export { DialogWrapperComponent } from "./components/wrapper/wrapper.component";
export { DialogComponent } from "./components/dialog/dialog.component";
export { DialogLoadingComponent } from "./components/loading/loading.component";
export { DialogAlertComponent } from "./components/alert/alert.component";
export { DialogConfirmComponent } from "./components/confirm/confirm.component";
export { DialogPromptComponent } from "./components/prompt/prompt.component";

export {
  DialogHeaderComponent
} from "./components/partials/header/header.component";
export {
  DialogTitleComponent,
  DialogHeadingTitleComponent
} from "./components/partials/title/title.component";
export {
  DialogSubtitleComponent,
  DialogHeadingSubtitleComponent
} from "./components/partials/subtitle/subtitle.component";
export {
  DialogCloseComponent,
  DialogCloseDirective
} from "./components/partials/close/close.component";
export {
  DialogDismissComponent,
  DialogDismissDirective
} from "./components/partials/dismiss/dismiss.component";
export {
  DialogContentComponent
} from "./components/partials/content/content.component";
export { DialogBodyComponent } from "./components/partials/body/body.component";
export {
  DialogFooterComponent
} from "./components/partials/footer/footer.component";

/**
 * @ignore
 */
@NgModule({
  declarations: [
    DialogWrapperComponent,
    DialogComponent,

    DialogHeaderComponent,
    DialogTitleComponent,
    DialogHeadingTitleComponent,
    DialogSubtitleComponent,
    DialogHeadingSubtitleComponent,
    DialogCloseComponent,
    DialogCloseDirective,
    DialogDismissComponent,
    DialogDismissDirective,
    DialogContentComponent,
    DialogBodyComponent,
    DialogFooterComponent
  ],
  entryComponents: [DialogComponent],
  imports: [
    CommonModule,

    ButtonModule,
    GenericModule,
    IconModule,
    MediaModule
  ],
  exports: [
    DialogWrapperComponent,

    DialogHeaderComponent,
    DialogTitleComponent,
    DialogHeadingTitleComponent,
    DialogSubtitleComponent,
    DialogHeadingSubtitleComponent,
    DialogCloseComponent,
    DialogCloseDirective,
    DialogDismissComponent,
    DialogDismissDirective,
    DialogContentComponent,
    DialogBodyComponent,
    DialogFooterComponent
  ],
  providers: [DialogBaseService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogBaseModule {}
